import { FinancialServiceProviderAdapters } from '@seapoint/server/enums';
import { AccountView } from '../../types/entity-types';

/**
 * Checks if an account is a Modulr account
 * @param account - The account to check
 * @returns true if the account uses Modulr FSP adapter
 */
export const isModulrAccount = (account: AccountView): boolean => {
  return account.fspAdapter === FinancialServiceProviderAdapters.MODULR;
};
